import React, {SyntheticEvent} from "react";

import {UiState} from "../../../ui-state";

import {Button} from "semantic-ui-react";
import {Icon} from "../../icon/icon";
import {autorun} from "mobx";

interface ElevationProfileButtonProps {
    active: boolean;
    uiStore: UiState;
    onClick: (tool: string | null) => void;
    small?: boolean;
}

export class ElevationProfileButton extends React.Component<ElevationProfileButtonProps, any> {
    watchHandles: any[] = [];
    autorunDisposers: any[] = [];
    constructor(props: ElevationProfileButtonProps) {
        super(props);
        this.state = {
            viewModel: null,
            isLoading: true,
            active: this.props.active
        };
        this.handleClick=this.handleClick.bind(this);
    }
    handleClick(event?: SyntheticEvent<HTMLButtonElement>): void {
        const {small, uiStore} = this.props;
        if (event) {
            event.currentTarget.blur();
        }
        const {active} = this.state;
        this.setState({active: !active});
        if (!active) {
            if (small) {
                uiStore.setSidebarVisible(false);
            }
            this.props.onClick("profile");
        } else {
            this.props.onClick(null);
        }
    }
    componentDidMount(): void {
        autorun(() => {
            const {uiStore} = this.props;
            if (uiStore.activeTool === "profile") {
                this.setState({active: true});
            } else {
                this.setState({active: false});
            }
        });
    }
    componentDidUpdate(prevProps: ElevationProfileButtonProps): void {
        if(prevProps.active !== this.props.active && this.state.active !== this.props.active){
            // this.setActive(this.props.active);
            this.setState({active: this.props.active});
        }
    }
    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
        this.autorunDisposers.forEach((disposer: any) => {
            disposer();
        });
        this.autorunDisposers.length = 0;
    }

    render(): JSX.Element | null {
        const {active} = this.state;
        return <div className={"geo-elevation-button"}>
            <Button
                active={active}
                compact
                toggle
                onClick={(e)=>this.handleClick(e)}
                size={"small"}>
                <Icon name={"chart_spline"}/> Höhenprofil</Button>
        </div>;
    }
}
